import React from 'react';

/**
 * Static dark backdrop used on the unauthenticated / pre-camera screens
 * (login, signup, onboarding, paywall). Replaces the live BackgroundCamera
 * so the OS camera-permission prompt fires only when the user actually
 * reaches a capture screen.
 *
 * Intentionally minimal: a radial gradient plus a subtle grid pattern,
 * matching the app's yellow-on-black identity without the noisy live feed.
 * Rendered as a fixed, negative-z-index layer so it sits behind everything.
 */
const AuthBackground: React.FC = () => {
  return (
    <div
      aria-hidden="true"
      className="absolute inset-0 pointer-events-none overflow-hidden"
      style={{ zIndex: 0 }}
    >
      {/* Base: deep black */}
      <div className="absolute inset-0 bg-black" />

      {/* Radial glow — centers a soft yellow wash behind the form */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at 50% 30%, rgba(250, 204, 21, 0.18) 0%, rgba(250, 204, 21, 0.04) 40%, rgba(0,0,0,0) 70%)',
        }}
      />

      {/* Grid pattern — techy/engineering feel aligned with PinCam being a
          construction-site tool. Very low opacity so it's felt more than seen. */}
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            'linear-gradient(to right, #facc15 1px, transparent 1px), linear-gradient(to bottom, #facc15 1px, transparent 1px)',
          backgroundSize: '40px 40px',
        }}
      />

      {/* Vignette — darken the edges for focus on the center */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse at center, transparent 40%, rgba(0,0,0,0.55) 100%)',
        }}
      />
    </div>
  );
};

export default AuthBackground;
